import { ReactNode } from 'react';
import { CenteredSpinner } from '~/commonComponents/CenteredSpinner';
import { AccountSplitWeb } from '~/constants/ff.posthog';
import { useFeatureFlagState } from '~/hooks/useFeatureFlagState';

interface IAccountSplitGateProps {
  /** Rendered with `GOTU-7475-account-split-web` on. */
  splitOn: ReactNode;
  /** Rendered with it off. */
  splitOff: ReactNode;
}

/**
 * Picks the account area's old or new route element. Waits for flags so
 * `/account` never bounces to `/locations` (or back) before PostHog answers.
 */
export const AccountSplitGate = ({ splitOn, splitOff }: IAccountSplitGateProps) => {
  const status = useFeatureFlagState(AccountSplitWeb);

  if (status === 'loading') return <CenteredSpinner />;
  return <>{status === 'enabled' ? splitOn : splitOff}</>;
};
